/**
 * toggleClass creates the on click listener for '.js-toggle-class'.
 *
 * The on click listener toggles the given class on the given element.
 * The '.js-toggle-class' element requires:
 * - data-toggle-element: String        (Element to toggle the class on, ie '#element' or '.element')
 * - data-toggle-class: String          (Class to toggle, ie 'is-closed')
 */

function toggleClass() {
	$(document).on('click', '.js-toggle-class', function() {
		const $this = $(this);
		const $target = $($this.data('toggle-element'));
		const clss = $this.data('toggle-class');
		$target.toggleClass(clss);
	});
}
toggleClass();
